var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{attrs:{"id":"searchPtenAgents"}},[_c('headerPtenAgent',{staticClass:"mt-16"}),_c('tablePtenAgent',{ref:"tablePtenAgent",staticClass:"mt-0 px-3",on:{"actionClick":_vm.actionClick}}),_c('navbarPten',{attrs:{"menuIndex":"0"},on:{"actionClick":_vm.actionClick}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }